(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.file.factory:File
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcfile')
    .factory('File', File);
  
  
  File.$inject = ['restmod'];
  function File(restmod) {
    return restmod.model('/routes/files').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/files/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            let realquery = {};
            realquery[key] = val;
            realquery.active = {$ne: false};
            return this.$search(realquery);
          },
          $searchMetaBy: function (key, val) {
            // TODO: this one is probably not needed, file collection only contains metadata
            let realquery = {active: {$ne: false}};
            realquery[key] = val;

            return this.$search(
              {
                query: realquery,
                options: {
                  fields: {
                    _id: true,
                    created: true,
                    type: true,
                    filename: true,
                    patientid: true,
                    invoicenr: true,
                    receiptnr: true,
                    examid: true
                  }
                }
              });
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
